export const TEMPLATE_PAGE_HEADER = "Survey Template";
export const GET_TEMPLATE_PAGE_SUBTITLE = (templateName: string) =>
  `To make changes to this template ("${templateName}"), print this page, pencil in changes, and send to a platform admin.`;

export const UNSAVED_CHANGES_PROMPT =
  "You have unsaved changes. Are you sure you want to leave?";

export const ATHLETE_COLUMN_HEADING = "Athlete";
export const COACH_COLUMN_HEADING = "Coach";

export const EXPECTATIONS_QUESTIONS_HEADING = "Expectations";
export const WARMTH_QUESTIONS_HEADING = "Relational Warmth";
export const WRITTEN_QUESTIONS_HEADING = "Written Response";
export const PARENT_QUESTIONS_HEADING = "Parent Questions";

export const PRINT_BUTTON_LABEL = "Print";



// WEBPACK FOOTER //
// ./src/pages/director/template-editor/constants.ts